module.exports = __webpack_public_path__ + "0dd6f7bca33c1a19a37e95113d944ba7.svg";